import { gql } from "@apollo/client";

export const GET_JOB_REQUISITIONS = gql`
    query GetJobRequisitions($department: [String], $designation: String) {
        getAllJobRequisition(department: $department, designation: $designation) {
        status
        message
        response {
            id
            requisitionId
            designation
            dept
            location
            employmentType
            workMode
            numberOfOpenings
            experienceRequired
            skillsRequired
            jobDescription
            jobResponsibilities
            salaryRange
            shift
            reasonForHiring
            approvalStatus
            status
            RequestedBy
            publishStatus
            notes
            createdAt
        }
        }
    }
`;

export const CREATE_JOB_REQUISITION = gql`
    mutation CreateJobRequisition($input: JobRequisitionInput) {
        createJobRequisition(input: $input) {
        status
        message
        response {
            id
            requisitionId
            designation
            dept
            assignedTo
            location
            employmentType
            workMode
            numberOfOpenings
            experienceRequired
            skillsRequired
            jobDescription
            jobResponsibilities
            salaryRange
            shift
            reasonForHiring
            approvalStatus
            status
            publishStatus
            RequestedBy
            notes
            createdAt
            questions{
id
type
label
options
required
}
interviewQuestions {
        questionId
        question
        category
        required
      }

      exam {
        enabled
        examTitle
        examLink
        durationInMinutes
        instructions
        passingScore
         questions {
          questionText
          type
          options
        }
      }

        }
}
}
`;

export const GET_SINGLE_JOB_REQUISITION = gql`
    query GetSingleJobRequisition($id: String!) {
        getSingleJobRequisition(id: $id) {
        status
        message
        response {
            id
            requisitionId
            designation
            dept
            assignedTo
            location
            employmentType
            workMode
            numberOfOpenings
            experienceRequired
            skillsRequired
            jobDescription
            jobResponsibilities
            salaryRange
            shift
            reasonForHiring
            approvalStatus
            publishedSources
            notes
             publishDate
            applySlug
            applyUrl
            createdAt
            questions{
id
type
label
options
required
}
interviewQuestions {
        questionId
        question
        category
        required
      }

      exam {
        enabled
        examTitle
        examLink
        durationInMinutes
        instructions
        passingScore
         questions {
          questionText
          type
          options
        }
      }

        }
    }
}
`;

export const UPDATE_JOB_DETAILS = gql`
mutation updateJobRequisition($id: String, $input: JobRequisitionInput){
updateJobRequisition(id: $id, input: $input){
        status
        message
        response {
            id
            requisitionId
            designation
            dept
            location
            employmentType
            workMode
            numberOfOpenings
            experienceRequired
            skillsRequired
            jobDescription
            jobResponsibilities
            salaryRange
            shift
            reasonForHiring
            notes
            createdAt
             questions{
id
type
label
options
required
}
interviewQuestions {
        questionId
        question
        category
        required
      }
          exam {
        enabled
        examTitle
        examLink
        durationInMinutes
        instructions
        passingScore
         questions {
          questionText
          type
          options
        }
        }
}
}
}
`;

export const UPDATE_PUBLISH_JOB_DETAILS = gql`
mutation updatePublishJobRequisition($id: String, $input: JobRequisitionInput){
updatePublishJobRequisition(id: $id, input: $input){
        status
        message
        response {
            id
            requisitionId
            designation
            dept
            location
            employmentType
            workMode
            numberOfOpenings
            experienceRequired
            skillsRequired
            jobDescription
            jobResponsibilities
            salaryRange
            shift
            reasonForHiring
            notes
            createdAt
             questions{
id
type
label
options
required
}

        }
}
}
`;

export const CREATE_JOB_POSTING = gql`
mutation CreateJobPosting($input: JobPostingInput){
createJobPosting(input: $input){
id
postingId
requisitionId
jobTitle
description
publishedSources
description
employmentType
publishStatus
location
questions{
id
type
label
options
required
}
}
}
`;

export const GET_JOBPOSTINGS = gql`
query getAllJobPostings{
getAllJobPostings{
  response {
            id
            requisitionId
            designation
            dept
            location
            employmentType
            workMode
            numberOfOpenings
            experienceRequired
            skillsRequired
            jobDescription
            jobResponsibilities
            salaryRange
            shift
            reasonForHiring
            approvalStatus
            publishStatus
            RequestedBy
            notes
              publishDate
      publishedSources
      applySlug
      applyUrl
            createdAt
        }
}
}
`;

export const PUBLISH_JOB_POSTING = gql`
  mutation PublishJobPosting($requisitionId: String!, $boards: [String!], $zones: String, $department: String, $expiryDate:String, $publishMode: String) {
    PublishJobPosting(requisitionId: $requisitionId, boards: $boards, zones: $zones, department: $department,expiryDate:$expiryDate, publishMode:$publishMode ) {
        status
    message
    response {
    requisitionId
      publishStatus
      publishDate
      publishedSources
      applySlug
      publishMode
      applyUrl
      createdAt
      updatedAt
    }
    }
  }
`;

export const CLOSE_JOBPOSTING = gql`
mutation CloseJobPosting($requisitionId: String){
CloseJobPosting(requisitionId: $requisitionId){
status
    message
    response {
      requisitionId
      publishStatus
      expiryDate
      approvalStatus
      publishDate
    }
}
}
`;

export const GET_PUBLISH_JOBDETAILS = gql`
query publicJobBySlug($slug: String!) {
  publicJobBySlug(slug: $slug) {
    postingId
    jobTitle
    description
    location
    employmentType
    responsibilities
    workMode
    salaryRange
    experienceRequired
    requirements
    publishedSources
  }
}
`;

export const APPLY_CANDIDATE = gql`
  mutation ApplyCandidate(
    $firstName: String
    $lastName: String
    $email: String
    $phone: String
    $experience: String
    $currentCTC: String
    $expectedCTC: String
    $resumeUrl: String
    $appliedSlug: String!
    $source: String
  ) {
    ApplyCandidate(
      firstName: $firstName
      lastName: $lastName
      experience: $experience
      email: $email
      phone: $phone
      currentCTC: $currentCTC
      expectedCTC: $expectedCTC
      resumeUrl: $resumeUrl
      appliedSlug: $appliedSlug
      source: $source
    ) {
      candidateId
      firstName
      lastName
      email
      phone
      experience
      currentCTC
      expectedCTC
      jobPostingId
      appliedSlug
      source
      status
    }
  }
`;

export const GET_JOB_POSTING_INSIGHTS = gql`
  query JobPostingInsightsData($requisitionId: String!) {
    JobPostingInsightsData(requisitionId: $requisitionId) {
      requisitionId
      jobTitle
      total
      applied
      screening
      interview
      offer
      hired
      rejected
    }
  }
`;

export const GET_ALLCANDIDATES_LIST = gql`
query getAllCandidateList($status: String, $source:[String], $department: String, $jobTitle: String, $experienceFrom: Float, $experienceTo: Float, $shift: String, $result: String, $requisitionId: String){
getAllCandidateList (status:$status, source: $source, department: $department, jobTitle: $jobTitle, experienceFrom: $experienceFrom, experienceTo: $experienceTo, shift:$shift, result: $result, requisitionId: $requisitionId){
id
  candidateId
    firstName
    lastName
    email
    phone
    experience
    currentCTC
    expectedCTC
    requisitionId
    jobTitle
    source
    status
    result
    resumeUrl
    createdAt
    approvalStatus
    createdBy
      updateHistory {
        editedBy
        editedAt
        changes {
          field
          oldValue
          newValue
        }
      }
}
}
`;

export const UPDATE_CANDIDATE_STATUS = gql`
  mutation UpdateCandidateStatus($candidateId: String!, $status: String!, $stage: String, $comments: String, $editedBy: String) {
    UpdateCandidateStatus(candidateId: $candidateId, status: $status, stage:$stage, comments: $comments, editedBy: $editedBy) {
      candidateId
      jobTitle
      firstName
      lastName
      email
      phone
      experience
      currentCTC
      expectedCTC
      source
      status
      stage
      comments
      createdAt
        updateHistory {
        editedBy
        editedAt
        changes {
          field
          oldValue
          newValue
        }
      }
    }
  }
`;

export const ADD_CANDIDATE_DETAILS = gql`
mutation addCandidateDetails($input: CandidateInputs){
addCandidateDetails(input: $input){
candidateId
firstName
lastName
resumeUrl
resumeFilename
currentRole
email
phone
department
currentCTC
expectedCTC
jobTitle
releventExperience
totalExperience
availability
status
createdAt
experience
source
approvalStatus
assignedRecruiter
createdBy
  updateHistory {
        editedBy
        createdAt
        changes {
          field
          oldValue
          newValue
        }
      }

}
}
`;

export const GET_CANDIDATE_DETAILS = gql`
query getCandidateDetailS($id:String!){
getCandidateDetails(id: $id){
id
candidateId
requisitionId
firstName
lastName
resumeUrl
resumeFilename
currentRole
email
phone
department
currentCTC
expectedCTC
jobTitle
releventExperience
totalExperience
experience
availability
answers
source
status
stage
comments
approvalStatus
createdAt
exam{
examId
score
submittedAt
answers{
question
answer
}
}
interviews {
        interviewId
        round
        mode
        interviewDate
        interviewers
        status
      }
          updateHistory {
        editedBy
        editedAt
        createdAt
        changes {
          field
          oldValue
          newValue
        }
      }

}
}
`;

export const GET_INTERVIEW_CANDIDATE_DETAILS = gql`
query getInterviewCandidates($candidateId: String){
getInterviewCandidates(candidateId: $candidateId){
id
candidateId
requisitionId
firstName
lastName
resumeUrl
currentRole
email
phone
department
currentCTC
expectedCTC
jobTitle
releventExperience
totalExperience
availability
source
status
interviews {
      interviewId
      requisitionId
      round
      mode
      interviewDate
      interviewers
      agenda
      status
      createdAt
      updatedAt
      interviewQuestionsSnapshot{
        questionId
        question
        category
        required
      }
    }
}
}
`;

export const SCHEDULE_INTERVIEW = gql`
  mutation ScheduleInterview($input: InterviewInput!) {
    ScheduleInterview(input: $input) {
      interviewId
      round
      mode
      interviewDate
      interviewers
      agenda
      status
    }
  }
`;

export const SUBMIT_INTERVIEW_FEEDBACK = gql`
  mutation SubmitInterviewFeedback($input: FeedbackInput!) {
    SubmitInterviewFeedback(input: $input) {
      interviewId
      status
      feedback {
        result
        comments
        communication
        skill
        attitude
        fit
      }
    }
  }
`;

export const GET_SELECTED_CANDIDATES = gql`
 query {
        GetSelectedCandidates {
          id
          candidateId
          requisitionId
          firstName
          lastName
          email
          phone
          jobTitle
          result
        }
      }
`;

export const SAVE_OFFER_DRAFT = gql`
mutation ($input: OfferInput!) {
  saveOfferDraft(input: $input) {
    offerId
    offerStatus
  }
}
`;

export const SEND_OFFER = gql`
mutation ($offerId: String!) {
  sendOfferLetter(offerId: $offerId) {
    offerStatus
  }
}
`;

export const CREATE_OFFER = gql`
mutation createOffer($input:OfferInput){
createOffer(input:$input){
offerId
offerStatus
}
}
`;

export const SEND_OFFER_DETAILS = gql`
mutation sendOffer($input:OfferInput){
sendOffer(input:$input){
offerId
offerStatus
offerLetterFile
}
}
`;

export const ACCEPT_OFFER_DETAILS = gql`
mutation acceptOffer($offerId:String){
acceptOffer(offerId: $offerId){
offerId
offerStatus
}
}
`;

export const DECLINE_OFFER_DETAILS = gql`
mutation declineOffer($offerId:String){
declineOffer(offerId: $offerId){
offerId
offerStatus
}
}
`;


export const GET_OFFER_DETAILS = gql`
query getOfferDetails($candidateId: String!) {
  getOfferDetails(candidateId: $candidateId) {
    offerId
    candidateId
    jobTitle
    offerStatus
    offeredCTC
    joiningDate
    offerLetterUrl
    createdAt
    updatedAt
  }
}
`;

export const GET_INTERVIEW_SCHEDULED_CANDIDATES = gql`
query{
getInterviewScheduleCandidates{
id
candidateId
firstName
lastName
resumeUrl
currentRole
email
phone
department
currentCTC
expectedCTC
jobTitle
releventExperience
totalExperience
availability
source
status
stage

}
}
`;
export const GET_INTERVIEW = gql`
query GetInterview($interviewId: String!) {
  getInterview(interviewId: $interviewId) {
    interviewId
    candidateId
    requisitionId
    round
    mode
    interviewDate
    interviewers
    agenda
    status
    interviewQuestionsSnapshot {
      questionId
      question
      category
      required
    }
    questionFeedback {
      questionId
      question
      category
      rating
      notes
    }
    feedback {
      communication
      skill
      attitude
      fit
      comments
      result
    }
  }
}
`;

export const GET_ALLINERVIEW_DETAILS = gql`
query{
getAllInterviews{
interviewId
    candidateId
    requisitionId
    round
    mode
    interviewDate
    interviewers
    agenda
    status
    interviewQuestionsSnapshot {
      questionId
      question
      category
      required
    }
    questionFeedback {
      questionId
      question
      category
      rating
      notes
    }
    feedback {
      communication
      skill
      attitude
      fit
      comments
      result
    }
}
}
`
